module.exports = __webpack_public_path__ + "img/warning.29871678.svg";